export enum PageType {
  SupplierManager = 'SUPPLIER_MANAGER',
  SupplierEmployee = 'SUPPLIER_EMPLOYEE',
  Visit = 'VISIT',
  AfterTraining = 'AFTER_TRAINING',
}
